import React, { useEffect, useCallback } from 'react';
import ReactFlow, { useNodesState, useEdgesState, addEdge, Controls, ReactFlowProvider } from 'reactflow';
import { NODE_TYPES, convertToDiagramData } from './utils/core';
import 'reactflow/dist/style.css';
import './css/main.scss';

const defaultViewport = { x: 0, y: 0, zoom: 1 };
const connectionLineStyle = { stroke: '#fff' };
const snapGrid = [20, 20];
let refInstance;

const JourneyBuilderDiagram = (props) => {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  useEffect(() => {
    const diagramData = convertToDiagramData(props);
    if (diagramData) {
      setNodes(diagramData.nodes);
      setEdges(diagramData.edges);
      if (refInstance) {
        setTimeout(() => {
          refInstance.fitView();
        });
      }
    }
  }, [props.data, props.showMetrics, props.isView]);

  const onConnect = useCallback(
    (params) =>
      setEdges((eds) => {
        addEdge({ ...params, animated: true, style: { stroke: '#fff' } }, eds);
      }),
    []
  );

  const onNodeClick = (event, node) => {
    props.onNodeClick(node);
  };

  const setReactFlowInstance = (instance) => {
    refInstance = instance;
  };

  return (
    <ReactFlowProvider>
      <ReactFlow
        onInit={(instance) => setReactFlowInstance(instance)}
        className="journey-workflow"
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={NODE_TYPES}
        connectionLineStyle={connectionLineStyle}
        snapToGrid
        snapGrid={snapGrid}
        defaultViewport={defaultViewport}
        fitView
        attributionPosition="bottom-left"
        onNodeClick={onNodeClick}
        preventScrolling={false}
        nodesConnectable={false} // Not allow users to do connecting nodes
      >
        <Controls />
      </ReactFlow>
    </ReactFlowProvider>
  );
};

export default JourneyBuilderDiagram;
